import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65f64e65"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_2 = {
  class: "flex flex-col justify-between",
  style: {"height":"1000px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xl md:text-xl font-bold" }, "Zuwegung Mast", -1))
const _hoisted_4 = { class: "content h-full max-h-full" }
const _hoisted_5 = { class: "mt-0 grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg col-span-8" }, "Allgemeine Punkte", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, " Frage ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold col-span-3 border-solid rounded-md whiteYellowBorderColor" }, " Beschreibung/Eingabewerte ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, " Weitere Eingaben ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span- text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, " Bewertung ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Beschaffenheit:", -1))
const _hoisted_12 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_13 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_14 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Bereich:", -1))
const _hoisted_16 = { class: "text-xs text-gray-500" }
const _hoisted_17 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Anzahl Bäume:", -1))
const _hoisted_19 = { class: "text-xs text-gray-500" }
const _hoisted_20 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Breite der Zuwegung bis:", -1))
const _hoisted_22 = { class: "text-xs text-gray-500" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-1" }, "Art:", -1))
const _hoisted_24 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-xs" }, "Gewicht:", -1))
const _hoisted_26 = { class: "text-xs text-gray-500" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-5" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-xs" }, "Höhe:", -1))
const _hoisted_29 = { class: "text-xs text-gray-500" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Ringverkehr:", -1))
const _hoisted_31 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "möglich?", -1))
const _hoisted_33 = { class: "text-xs text-gray-500" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Ausweichflächen:", -1))
const _hoisted_35 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_36 = { class: "text-xs col-span-2" }
const _hoisted_37 = { class: "text-xs text-gray-500" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Alternative Zufahrt:", -1))
const _hoisted_39 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_40 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_41 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4 text-lg md:text-lg" }, "Grabenquerungen", -1))
const _hoisted_43 = { key: 0 }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-8 justify-items-stretch items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, " Frage "),
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold col-span-3 border-solid rounded-md whiteYellowBorderColor" }, " Beschreibung/Eingabewerte "),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, " Weitere Eingaben "),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span- text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, " Bewertung ")
], -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Art: ", -1))
const _hoisted_46 = { class: "text-xs col-span-3" }
const _hoisted_47 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_48 = { class: "justify-self-end row-span-2" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-xs" }, "Abstand", -1))
const _hoisted_50 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs md:text-xs" }, "Typ:", -1))
const _hoisted_52 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-2 grid grid-cols-8 justify-items-stretch items-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "justify-center items-center col-span-8",
    style: {"background-color":"rgb(235, 239, 240)","border-style":"solid","border-color":"rgb(235, 239, 240) rgb(235, 239, 240)\n                    rgb(235, 239, 240) rgb(235, 239, 240)","border-radius":"5px"}
  }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-center" }, " Keine Grabenquerungen aufgenommen ")
  ])
], -1))
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg" }, "Bauwerke", -1))
const _hoisted_57 = { key: 2 }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-8 justify-items-stretch items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, " Frage "),
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold col-span-3 border-solid rounded-md whiteYellowBorderColor" }, " Beschreibung/Eingabewerte "),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, " Weitere Eingaben "),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span- text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, " Bewertung ")
], -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2 ml-2 mt-2" }, "Bauwerke:", -1))
const _hoisted_60 = { class: "text-xs col-span-3 text-gray-500" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs md:text-xs" }, "Tragfähig:", -1))
const _hoisted_62 = { class: "text-xs text-gray-500" }
const _hoisted_63 = { class: "justify-self-end row-span-2" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-2" }, null, -1))
const _hoisted_65 = { class: "text-xs col-span-3 text-gray-500" }
const _hoisted_66 = { key: 3 }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "justify-center items-center col-span-8",
  style: {"background-color":"rgb(235, 239, 240)","border-style":"solid","border-color":"rgb(235, 239, 240) rgb(235, 239, 240)\n                    rgb(235, 239, 240) rgb(235, 239, 240)","border-radius":"5px"}
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-center" }, " Keine Bauwerke aufgenommen ")
], -1))
const _hoisted_68 = [
  _hoisted_67
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tng_header = _resolveComponent("tng-header")!
  const _component_bewertung_chip = _resolveComponent("bewertung-chip")!
  const _component_is_vorhanden_char_and_label = _resolveComponent("is-vorhanden-char-and-label")!
  const _component_oneto_five_image_div = _resolveComponent("oneto-five-image-div")!
  const _component_PdfChip = _resolveComponent("PdfChip")!
  const _component_bauflaechen_footer = _resolveComponent("bauflaechen-footer")!
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!

  return (_openBlock(), _createBlock(_component_pdf_a4_page, {
    "no-margin": "",
    "pdf-key": _ctx.lang,
    class: "pdf-content"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_tng_header, {
            ba: _ctx.ba,
            immobilie: _ctx.immobilie,
            lang: _ctx.lang
          }, null, 8, ["ba", "immobilie", "lang"]),
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _hoisted_8,
              _hoisted_9,
              _hoisted_10,
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'rippistein-bauflaechen.zuwegung-mast-tab.beschaffenheit.beschaffenheit'
                )['eingabeMehrfachAuswahlWerts'], (v, key) => {
                  return (_openBlock(), _createElementBlock("ul", {
                    key: key,
                    class: ""
                  }, [
                    (_openBlock(), _createElementBlock("li", {
                      key: key,
                      class: "text-xs text-gray-500"
                    }, _toDisplayString(v), 1))
                  ]))
                }), 128))
              ]),
              _createVNode(_component_bewertung_chip, {
                "frages-path": "rippistein-bauflaechen.zuwegung-mast-tab.beschaffenheit.beschaffenheit-bewertung",
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang,
                class: "justify-self-end"
              }, null, 8, ["ba", "immobilie", "lang"]),
              _createVNode(_component_is_vorhanden_char_and_label, {
                ba: _ctx.ba,
                "frages-path": "rippistein-bauflaechen.zuwegung-mast-tab.gefaelle.gefaelle-vorhanden",
                label: "Gefälle",
                class: "col-span-2"
              }, null, 8, ["ba"]),
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'rippistein-bauflaechen.zuwegung-mast-tab.gefaelle.gefaelle-beschreibung'
                )['eingabeText']), 1),
              _createVNode(_component_bewertung_chip, {
                "frages-path": "rippistein-bauflaechen.zuwegung-mast-tab.gefaelle.gefaelle-bewertung",
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang,
                class: "justify-self-end"
              }, null, 8, ["ba", "immobilie", "lang"]),
              _createVNode(_component_oneto_five_image_div, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                "frages-path": "rippistein-bauflaechen.zuwegung-mast-tab.gefaelle.gefaelle-bilder",
                lang: _ctx.lang,
                class: "col-span-8"
              }, null, 8, ["ba", "immobilie", "lang"]),
              _createVNode(_component_is_vorhanden_char_and_label, {
                ba: _ctx.ba,
                "frages-path": "rippistein-bauflaechen.zuwegung-mast-tab.ausholzung.ausholzung-erforderlich",
                label: "Ausholzung erforderlich",
                class: "col-span-2"
              }, null, 8, ["ba"]),
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'rippistein-bauflaechen.zuwegung-mast-tab.ausholzung.ausholzung-beschreibung'
                )['eingabeText']), 1),
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                   "rippistein-bauflaechen.zuwegung-mast-tab.ausholzung.ausholzung-bereich"
                )['eingabeAuswahlWert']), 1),
              _createVNode(_component_bewertung_chip, {
                "frages-path": "rippistein-bauflaechen.zuwegung-mast-tab.ausholzung.ausholzung-bewertung",
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang,
                class: "justify-self-end"
              }, null, 8, ["ba", "immobilie", "lang"]),
              _createVNode(_component_oneto_five_image_div, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                "frages-path": "rippistein-bauflaechen.zuwegung-mast-tab.ausholzung.ausholzung-bilder",
                lang: _ctx.lang,
                class: "col-span-8"
              }, null, 8, ["ba", "immobilie", "lang"]),
              _createVNode(_component_is_vorhanden_char_and_label, {
                ba: _ctx.ba,
                "frages-path": "rippistein-bauflaechen.zuwegung-mast-tab.rodung.rodung-erforderlich",
                label: "Rodung erforderlich",
                class: "col-span-2"
              }, null, 8, ["ba"]),
              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'rippistein-bauflaechen.zuwegung-mast-tab.rodung.rodung-beschreibung'
                )['eingabeText']), 1),
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'rippistein-bauflaechen.zuwegung-mast-tab.rodung.anzahl-baeume'
                )['eingabeText']), 1),
              _createVNode(_component_bewertung_chip, {
                "frages-path": "rippistein-bauflaechen.zuwegung-mast-tab.rodung.rodung-bewertung",
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang,
                class: "justify-self-end"
              }, null, 8, ["ba", "immobilie", "lang"]),
              _createVNode(_component_oneto_five_image_div, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                "frages-path": "rippistein-bauflaechen.zuwegung-mast-tab.rodung.rodung-bilder",
                lang: _ctx.lang,
                class: "col-span-8"
              }, null, 8, ["ba", "immobilie", "lang"]),
              _createVNode(_component_is_vorhanden_char_and_label, {
                ba: _ctx.ba,
                "frages-path": "rippistein-bauflaechen.zuwegung-mast-tab.ausholzung.ausholzung-erforderlich",
                label: "Breite der Zuwegung",
                class: "col-span-2"
              }, null, 8, ["ba"]),
              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'rippistein-bauflaechen.zuwegung-mast-tab.zuwegung.zuwegung-breite-beschreibung'
                )['eingabeText']), 1),
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'rippistein-bauflaechen.zuwegung-mast-tab.zuwegung.zuwegung-breitevonbis'
                )?.['eingabeText']), 1),
              _createVNode(_component_bewertung_chip, {
                "frages-path": "rippistein-bauflaechen.zuwegung-mast-tab.zuwegung.zuwegung-breite-bewertung",
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang,
                class: "justify-self-end"
              }, null, 8, ["ba", "immobilie", "lang"]),
              _createVNode(_component_is_vorhanden_char_and_label, {
                ba: _ctx.ba,
                "frages-path": "rippistein-bauflaechen.zuwegung-mast-tab.beschraenkung.beschraenkung-vorhanden",
                label: "Beschränkung vorhanden",
                class: "col-span-2"
              }, null, 8, ["ba"]),
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'rippistein-bauflaechen.zuwegung-mast-tab.beschraenkung.beschraenkung-art'
                )['eingabeMehrfachAuswahlWerts'], (v, key) => {
                  return (_openBlock(), _createElementBlock("ul", {
                    key: key,
                    class: ""
                  }, [
                    (_openBlock(), _createElementBlock("li", {
                      key: key,
                      class: "text-xs text-gray-500"
                    }, _toDisplayString(v), 1))
                  ]))
                }), 128))
              ]),
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'rippistein-bauflaechen.zuwegung-mast-tab.beschraenkung.beschraenkung-gewicht-wert'
                )['eingabeText']), 1),
              _createVNode(_component_bewertung_chip, {
                "frages-path": "rippistein-bauflaechen.zuwegung-mast-tab.beschraenkung.beschraenkung-gewicht-bewertung",
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang,
                class: "justify-self-end"
              }, null, 8, ["ba", "immobilie", "lang"]),
              _hoisted_27,
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'rippistein-bauflaechen.zuwegung-mast-tab.beschraenkung.beschraenkung-hoehe-wert'
                )['eingabeText']), 1),
              _createVNode(_component_bewertung_chip, {
                "frages-path": "rippistein-bauflaechen.zuwegung-mast-tab.beschraenkung.beschraenkung-hoehe-bewertung",
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang,
                class: "justify-self-end"
              }, null, 8, ["ba", "immobilie", "lang"]),
              _hoisted_30,
              _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'rippistein-bauflaechen.zuwegung-mast-tab.ringverkehr.ringverkehr-beschreibung'
                )['eingabeText']), 1),
              _hoisted_32,
              _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'rippistein-bauflaechen.zuwegung-mast-tab.ringverkehr.ringverkehr-moeglich'
                )['eingabeAuswahlWert']), 1),
              _createVNode(_component_bewertung_chip, {
                "frages-path": "rippistein-bauflaechen.zuwegung-mast-tab.ringverkehr.ringverkehr-bewertung",
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang,
                class: "justify-self-end"
              }, null, 8, ["ba", "immobilie", "lang"]),
              _hoisted_34,
              _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'rippistein-bauflaechen.zuwegung-mast-tab.ausweichflaechen.ausweichflaechen-beschreibung'
                )['eingabeText']), 1),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'rippistein-bauflaechen.zuwegung-mast-tab.ausweichflaechen.ausweichflaechen'
                )['eingabeAuswahlWert']), 1)
              ]),
              _createVNode(_component_bewertung_chip, {
                "frages-path": "rippistein-bauflaechen.zuwegung-mast-tab.ausweichflaechen.ausweichflaechen-bewertung",
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang,
                class: "justify-self-end"
              }, null, 8, ["ba", "immobilie", "lang"]),
              _hoisted_38,
              _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'rippistein-bauflaechen.zuwegung-mast-tab.alternative-zufahrt.alternative-zufahrt-beschreibung'
                )['eingabeText']), 1),
              _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'rippistein-bauflaechen.zuwegung-mast-tab.alternative-zufahrt.alternative-zufahrt'
                )['eingabeAuswahlWert']), 1),
              _createVNode(_component_bewertung_chip, {
                "frages-path": "rippistein-bauflaechen.zuwegung-mast-tab.alternative-zufahrt.alternative-zufahrt-bewertung",
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang,
                class: "justify-self-end"
              }, null, 8, ["ba", "immobilie", "lang"]),
              _createVNode(_component_is_vorhanden_char_and_label, {
                ba: _ctx.ba,
                "frages-path": "rippistein-bauflaechen.zuwegung-mast-tab.sonstiges.sonstiges-vorhanden",
                label: "Sonstiges",
                class: "col-span-2"
              }, null, 8, ["ba"]),
              _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'rippistein-bauflaechen.zuwegung-mast-tab.sonstiges.sonstiges'
                )['eingabeText']), 1),
              _createVNode(_component_bewertung_chip, {
                "frages-path": "rippistein-bauflaechen.zuwegung-mast-tab.sonstiges.sonstiges-bewertung",
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang,
                class: "justify-self-end"
              }, null, 8, ["ba", "immobilie", "lang"])
            ]),
            _hoisted_42,
            (_ctx.getGrabenquerungen(_ctx.ba).length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _hoisted_44,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getGrabenquerungen(_ctx.ba), (grabenquerung, key) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: key,
                      class: "ml-2 grid grid-cols-8 justify-items-stretch items-center",
                      style: {"border-style":"solid","border-color":"var(--white100) var(--white100) var(--white100) rgb(216, 215, 26)","border-radius":"5px"}
                    }, [
                      _hoisted_45,
                      _createElementVNode("div", _hoisted_46, _toDisplayString(grabenquerung['art']), 1),
                      _createElementVNode("div", _hoisted_47, _toDisplayString(grabenquerung['graben-beschreibung']), 1),
                      _createElementVNode("div", _hoisted_48, [
                        ('plus' === grabenquerung['graben-bewertung'])
                          ? (_openBlock(), _createBlock(_component_PdfChip, {
                              key: 0,
                              color: "green",
                              "mangel-amount-mode": "",
                              value: "1",
                              "pdf-mode": ""
                            }))
                          : _createCommentVNode("", true),
                        ('o' === grabenquerung['graben-bewertung'])
                          ? (_openBlock(), _createBlock(_component_PdfChip, {
                              key: 1,
                              color: "blue",
                              "mangel-amount-mode": "",
                              value: "1",
                              "pdf-mode": ""
                            }))
                          : _createCommentVNode("", true),
                        ('minus' === grabenquerung['graben-bewertung'])
                          ? (_openBlock(), _createBlock(_component_PdfChip, {
                              key: 2,
                              color: "yellow",
                              "mangel-amount-mode": "",
                              value: "1",
                              "pdf-mode": ""
                            }))
                          : _createCommentVNode("", true),
                        ('x' === grabenquerung['graben-bewertung'])
                          ? (_openBlock(), _createBlock(_component_PdfChip, {
                              key: 3,
                              color: "red",
                              "mangel-amount-mode": "",
                              value: "1",
                              "pdf-mode": ""
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_49,
                      _createElementVNode("div", _hoisted_50, _toDisplayString(grabenquerung['abstand'] ==null ? '': grabenquerung['abstand']), 1),
                      _hoisted_51,
                      _createElementVNode("div", _hoisted_52, _toDisplayString(grabenquerung['graben-typ']), 1),
                      _createVNode(_component_oneto_five_image_div, {
                        ba: null,
                        immobilie: null,
                        fragesPath: "null",
                        lang: _ctx.lang,
                        imageObjects: grabenquerung['graben-foto'],
                        class: "ml-2 col-span-8"
                      }, null, 8, ["lang", "imageObjects"])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_53, _hoisted_55)),
            _hoisted_56,
            (_ctx.getBauwerke(_ctx.ba).length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                  _hoisted_58,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getBauwerke(_ctx.ba), (bauwerk, key) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: key,
                      class: "ml-2 mt-2 grid grid-cols-8 justify-items-stretch items-center",
                      style: {"border-style":"solid","border-color":"var(--white100) var(--white100) var(--white100) rgb(216, 215, 26)","border-radius":"5px"}
                    }, [
                      _hoisted_59,
                      _createElementVNode("div", _hoisted_60, _toDisplayString(bauwerk['freitext']), 1),
                      _hoisted_61,
                      _createElementVNode("div", _hoisted_62, _toDisplayString(bauwerk['tragfaehig']), 1),
                      _createElementVNode("div", _hoisted_63, [
                        ('plus' === bauwerk['bauwerk-bewertung'])
                          ? (_openBlock(), _createBlock(_component_PdfChip, {
                              key: 0,
                              color: "green",
                              "mangel-amount-mode": "",
                              value: "1",
                              "pdf-mode": ""
                            }))
                          : _createCommentVNode("", true),
                        ('o' === bauwerk['bauwerk-bewertung'])
                          ? (_openBlock(), _createBlock(_component_PdfChip, {
                              key: 1,
                              color: "blue",
                              "mangel-amount-mode": "",
                              value: "1",
                              "pdf-mode": ""
                            }))
                          : _createCommentVNode("", true),
                        ('minus' === bauwerk['bauwerk-bewertung'])
                          ? (_openBlock(), _createBlock(_component_PdfChip, {
                              key: 2,
                              color: "yellow",
                              "mangel-amount-mode": "",
                              value: "1",
                              "pdf-mode": ""
                            }))
                          : _createCommentVNode("", true),
                        ('x' === bauwerk['bauwerk-bewertung'])
                          ? (_openBlock(), _createBlock(_component_PdfChip, {
                              key: 3,
                              color: "red",
                              "mangel-amount-mode": "",
                              value: "1",
                              "pdf-mode": ""
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_64,
                      _createElementVNode("div", _hoisted_65, _toDisplayString(bauwerk['beschreibung']), 1),
                      _createVNode(_component_oneto_five_image_div, {
                        ba: null,
                        immobilie: null,
                        fragesPath: "null",
                        lang: _ctx.lang,
                        imageObjects: bauwerk['bild'],
                        class: "ml-2 col-span-8"
                      }, null, 8, ["lang", "imageObjects"])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_66, _hoisted_68))
          ])
        ]),
        _createVNode(_component_bauflaechen_footer, {
          ba: _ctx.ba,
          immobilie: _ctx.immobilie,
          lang: _ctx.lang
        }, null, 8, ["ba", "immobilie", "lang"])
      ])
    ]),
    _: 1
  }, 8, ["pdf-key"]))
}